import React from 'react';
import { ThemeContext, useThemeProvider } from '../hooks/use-theme';

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useThemeProvider();
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
